import _ from 'lodash'
import Constants from '@/utils/Constants'
import { isStoreAnalysis } from '@/utils/business'

const targetNames = [
  {
    title: 'フリーワード検索',
    key: 'add_code'
  },
  {
    title: '除外商品',
    key: 'delete_code'
  },
  {
    title: '名前から選択',
    key: 'name'
  }
]

export const tabNames = {
  IF00002: [
    {
      index: 0,
      key: 'gender_age_10',
      text: '性年代別(10歳刻み)'
    },
    {
      index: 1,
      key: 'gender_age_5',
      text: '性年代別(5歳刻み)'
    },
    {
      index: 2,
      key: 'age_10',
      text: '年代別(10歳刻み)'
    },
    {
      index: 3,
      key: 'age_5',
      text: '年代別(5歳刻み)'
    }
  ],
  IF00003: [
    {
      index: 0,
      key: 'item',
      text: '商品別'
    },
    {
      index: 1,
      key: 'age_10',
      text: '性年代別(10歳刻み)'
    },
    {
      index: 2,
      key: 'age_5',
      text: '性年代別(5歳刻み)'
    }
  ],
  IF00004: [
    {
      index: 0,
      key: 'all',
      text: '性年代なし'
    },
    {
      index: 1,
      key: 'age_10',
      text: '性年代別(10歳刻み)'
    },
    {
      index: 2,
      key: 'age_5',
      text: '性年代別(5歳刻み)'
    }
  ],
  IF00005: [
    {
      index: 0,
      key: 'all',
      text: '年代なし'
    },
    {
      index: 1,
      key: 'age_10',
      text: '年代別(10歳刻み)'
    },
    {
      index: 2,
      key: 'age_5',
      text: '年代別(5歳刻み)'
    }
  ],
  IF00022: [
    {
      index: 0,
      key: 'gender',
      text: '性別'
    },
    {
      index: 1,
      key: 'age_10',
      text: '年代別(10歳刻み)'
    },
    {
      index: 2,
      key: 'age_5',
      text: '年代別(5歳刻み)'
    },
    {
      index: 3,
      key: 'gender_age_10',
      text: '性年代別(10歳刻み)'
    },
    {
      index: 4,
      key: 'gender_age_5',
      text: '性年代別(5歳刻み)'
    }
  ],
  IF00013: [
    {
      index: 0,
      key: 'item_category',
      text: '商品分類別'
    },
    {
      index: 1,
      key: 'store',
      text: '店舗別'
    },
    {
      index: 2,
      key: 'item',
      text: '商品別'
    }
  ],
  IF00019: [
    {
      index: 0,
      key: 'item_category',
      text: '商品分類別一覧'
    },
    {
      index: 1,
      key: 'item_week',
      text: '商品別推移（週別）'
    },
    {
      index: 2,
      key: 'item_day',
      text: '商品別推移（日別）'
    }
  ],
  IF00020: [
    {
      index: 0,
      key: 'price',
      text: '価格帯'
    },
    {
      index: 1,
      key: 'item',
      text: '商品別'
    }
  ],
  IF00021: [
    {
      index: 0,
      key: 'item',
      text: '商品別'
    }
  ],
  IF00021_3: [
    {
      index: 0,
      key: 'maker',
      text: 'メーカー別'
    },
    {
      index: 1,
      key: 'item',
      text: '商品別'
    }
  ],
  IF00021_4: [
    {
      index: 0,
      key: 'supplier',
      text: '仕入先別'
    },
    {
      index: 1,
      key: 'item',
      text: '商品別'
    }
  ],
  IF00029: [
    {
      index: 0,
      key: 'cd3',
      text: '小分類'
    },
    {
      index: 1,
      key: 'cd4',
      text: '細分類'
    }
  ],
  IF00010: [
    {
      index: 0,
      key: '',
      text: '集計結果'
    },
    {
      index: 1,
      key: 'item',
      text: '商品別'
    },
    {
      index: 2,
      key: 'store',
      text: '店舗別'
    }
  ]
}

// const targetPath = 'product.item_target'
export default {
  getTabData (analyzeId) {
    let tabs = []
    if (_(tabNames).has(analyzeId)) {
      if (analyzeId === 'IF00021') {
        const division = Constants.getContract('division')
        if (division === 3) {
          tabs = _(tabNames).get('IF00021_3')
        } else if (division === 4) {
          tabs = _(tabNames).get('IF00021_4')
        } else {
          tabs = _(tabNames).get(analyzeId)
        }
      } else if (analyzeId === 'IF00013') {
        if (!isStoreAnalysis()) {
          return _.filter(_(tabNames).get(analyzeId), (tab) => {
            return tab.key !== 'store'
          })
        }
        return _(tabNames).get(analyzeId)
      } else {
        tabs = _(tabNames).get(analyzeId)
      }
    }
    return tabs
  },
  hasTargetTerm (condition) {
    if (_(condition).has('term.search_term_target')) {
      return true
    }
    return false
  },
  getAnalyzeCondition (conditionJP, kind) {
    let items = []

    let analyze = _(conditionJP).get('product.' + kind + '.analyze')
    if (_.isObject(analyze)) {
      _.forEach(analyze, function (value, key) {
        console.log(key)
        if (Array.isArray(value)) {
          let item = _.find(targetNames, function (o) { return o.key === key })
          if (_.isObject(item) && !_.isEmpty(value)) {
            item.codes = value
            items.push(item)
          }
        }
      })
    }
    console.log(items)
    return items
  },
  getCellClasses (targetCode, srcField, destField, type) {
    let classes = []
    let addClass = {}
    if (targetCode === 'IF00029') {
      addClass = {
        class: 'td-over11',
        condition: row => {
          if (!row[destField]) return false
          return Math.round(row[srcField] * 100.0 / row[destField]) / 100 >= 1.10
        }
      }
      classes.push(addClass)
      addClass = {
        class: 'td-under09',
        condition: row => {
          if (!row[destField]) return false
          return Math.round(row[srcField] * 100.0 / row[destField]) / 100 <= 0.90
        }
      }
      classes.push(addClass)
    } else if (targetCode === 'IF00024') {
      addClass = {
        class: 'td-over11',
        condition: row => {
          if (!row[srcField]) return false
          if (type === 'percent') {
            return parseFloat(row[srcField]) * 100 >= 1.10
          } else if (type === 'int') {
            return parseInt(row[srcField]) >= 1.10
          } else {
            return parseFloat(row[srcField]) >= 1.10
          }
        }
      }
      classes.push(addClass)
      addClass = {
        class: 'td-under09',
        condition: row => {
          if (!row[srcField]) return true
          if (type === 'percent') {
            return parseFloat(row[srcField]) * 100 <= 0.90
          } else if (type === 'int') {
            return parseInt(row[srcField]) <= 0.90
          } else {
            return parseFloat(row[srcField]) <= 0.90
          }
        }
      }
      classes.push(addClass)
    }
    return classes
  },
  analyze_without_product (analyzeTargetCode) {
    return _.indexOf(['IF00008', 'IF00022', 'IF00024', 'IF00026', 'IF00027', 'IF00028', 'IF00029'], analyzeTargetCode) >= 0
  }
}
